import * as React from "react";
import ActivityBadge from "./ActivityBadge";
import { Avatar, Stack, Typography } from "@mui/material";
import { useImageBuilder } from "../../utils/image";

import avatar from "../../assets/images/users/default-avatar.jpg";
import { User } from "../../store/types";
import { FileMetadata } from "../../api/types/cms";
import { PropsWithChildren, useMemo } from "react";
import { PublicUser } from "../../api/types/user";

type UserItemProps = {
  user: User | PublicUser;
  spacing?: boolean;
  trackUserActivity?: boolean;
  showBadge?: boolean;
  showRipple?: boolean;
  showEmail?: boolean;
  alternativeImage?: FileMetadata | null;
  width?: string | number;
  forceFullName?: boolean;
};

export default function UserItem({
                                   user,
                                   spacing = false,
                                   trackUserActivity = false,
                                   showBadge = false,
                                   showRipple = false,
                                   showEmail = false,
                                   alternativeImage = null,
                                   children,
                                   width = "100%",
                                   forceFullName = false
                                 }: PropsWithChildren<UserItemProps>) {
  const { buildImageUrl } = useImageBuilder();
  const image = user?.image;

  return useMemo(() => {
    return (
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ p: spacing ? 0.5 : 0 }}>
        <ActivityBadge
          user={user}
          trackUserActivity={trackUserActivity}
          showBadge={showBadge}
          showRipple={showRipple}>
          <Avatar
            alt="profile user"
            src={
              (image || alternativeImage)
                ? buildImageUrl(image ?? alternativeImage, 50, 50)
                : avatar
            }
            sx={{ width: 32, height: 32 }}
          />
        </ActivityBadge>
        <Stack spacing={-0.5} alignItems="start" sx={{ width }}>
          <Typography
            variant="subtitle1"
            className="cutTextEnd"
            sx={{ width: "100%" }}>
            {
              // @ts-ignore
              (user?.display_name && !forceFullName)
                ? user?.display_name
                // @ts-ignore
                : user?.firstname
                  // @ts-ignore
                  ? `${user?.firstname ?? ""} ${user?.lastname}`
                  // @ts-ignore
                  : user?.email?.split("@")?.at(0)
            }
          </Typography>
          {
            // @ts-ignore
            showEmail && user?.email && (
              <Typography
                variant="subtitle2"
                color="text.secondary">
                {
                  // @ts-ignore
                  user?.firstname ? user.email : ""
                }
              </Typography>
            )
          }
          {children}
        </Stack>
      </Stack>
    );
  }, [user?.id, image, alternativeImage, buildImageUrl, children]);
}
